import { Reducer as routerReducer } from 'modules/router';
import routerReducerMock from './reducers-mock/router.reducer.mock';

import { Reducer as loginReducer } from 'modules/login';
import loginReducerMock from './reducers-mock/login.reducer.mock';

import { Reducer as languageReducer } from 'modules/language-provider';

import { Reducer as loadingManagerReducer } from 'modules/loading-manager';
import loadingManagerReducerMock from './reducers-mock/loading-manager.reducer.mock';

import { Reducer as friendsReferralReducer } from '../modules/friends-referral';
import friendsReferralReducerMock from './reducers-mock/friends-referral.reducer.mock';

const reducers = {
    [routerReducer.reducerKey]: routerReducerMock,
    [loginReducer.reducerKey]: loginReducerMock,
    [languageReducer.reducerKey]: languageReducer.default,
    [loadingManagerReducer.reducerKey]: loadingManagerReducerMock,
    [friendsReferralReducer.reducerKey]: friendsReferralReducerMock,
};

export default reducers;
